export default __webpack_public_path__ + "static/media/benefit1.d5c60c8c.svg";